import React from "react";

function Ourstory() {
  return (
    <div className="lg:py-10 lg:px-[50px] px-[16px] font-dmSans">
      <div className="text-left">
        <h2 className="text-[32px] font-medium text-[#182948] font-playfair">
          Our Team
        </h2>
        <div className="border-b-[7px] rounded-full lg:w-[150px] w-[140px] border-[#ABC452]  lg:mx-0 mt-2"></div>

        <p className="text-[#555555] mt-5 lg:text-[20px] text-[16px] lg:leading-[36px] leading-[32px]">
          Our team comprises skilled professionals with diverse backgrounds in
          branding, design, development, and marketing. We are passionate about
          what we do and are dedicated to delivering exceptional results. Each
          team member brings a unique perspective and expertise, allowing us to
          tackle projects of any complexity.
        </p>
      </div>
    </div>
  );
}

export default Ourstory;
